/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import * as React from "react"
import { X } from "react-feather"

/* -------------------------------------------------------------------------- */
/*                                 Components                                 */
/* -------------------------------------------------------------------------- */
const CookieSetting = props => {
  const [isEnabled, setIsEnabled] = React.useState(
    props.consentTypes?.every(
      consentType => props.storedConsentTypes?.includes(consentType),
    ),
  )
  const isMounted = React.useRef(false)
  React.useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }
    if (isMounted.current) {
      isEnabled
        ? props.addSelectedConsentTypes(props.consentTypes)
        : props.removeSelectedConsentTypes(props.consentTypes)
    }
  }, [isEnabled])
  return (
    <div>
      {/* Heading Container */}
      <div className="flex justify-between items-center">
        <div className="font-variant-numeric--primary font-bold leading-[36px] [margin-block-end:7px] text-[20px] text-grey-7">
          {props.heading}
        </div>
        {/* Toggle Container */}
        <div className="flex gap-[12px] items-center">
          <button
            className={`[--button-padding:2px] ${
              props.isEnabledDisabled
                ? "bg-[#AED1F5] cursor-not-allowed"
                : isEnabled
                  ? "bg-pacific-blue"
                  : "bg-grey-4"
            } p-[var(--button-padding)] rounded-[100px] transition-all w-[36px]`}
            onClick={() =>
              !props.isEnabledDisabled &&
              setIsEnabled(prevIsEnabled => !prevIsEnabled)
            }
            disabled={props.isEnabledDisabled}
          >
            <div
              className={`[--size: 18px] bg-white [box-shadow:0_2px_4px_0_rgba(39,39,39,0.10)] h-[var(--size)] rounded-full w-[var(--size)] ${
                isEnabled
                  ? `translate-x-[calc(var(--size)-(var(--button-padding)*2))]`
                  : `translate-x-0`
              } transition-all`}
              style={{
                "--size": "18px",
              }}
            ></div>
          </button>
          <span className="font-[500] font-['Inter'] leading-[26px] text-[16px] text-black -tracking-[.32px]">
            Enabled
          </span>
        </div>
      </div>
      {/* Description */}
      <div className="font-['Inter'] leading-[32px] text-[18px] text-grey-5">
        {props.description}
      </div>
    </div>
  )
}

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function CookiePopup(props) {
  const [selectedConsentTypes, setSelectedConsentTypes] = React.useState(
    props.consentTypes.essential,
  )
  const cookieSettings = [
    {
      heading: `Strictly Necessary Cookies`,
      description: (
        <>
          These cookies (and similar technologies) are necessary for the site to
          function and cannot be switched off in our systems. These include
          security and basic site features. Strictly Necessary information
          collection does not store any personally identifiable information.
        </>
      ),
      isEnabledDisabled: true,
      consentTypes: props.consentTypes.essential,
    },
    {
      heading: `Marketing Cookies`,
      description: (
        <>
          Used to show you relevant advertising and measure the effectiveness of
          our marketing campaigns. These may be set by us or third-party
          advertising partners.
        </>
      ),
      consentTypes: props.consentTypes.nonEssential.marketing,
    },
  ]

  return (
    <div className="bg-[#F9F9F9] grid max-h-[90%] max-w-[784px] overflow-y-auto [padding:24px] w-full">
      {/* Main Content */}
      <div className="[--gap:52px] flex flex-col [margin-inline:auto] max-w-[640px]">
        <button className="self-end" onClick={() => props.closeModal()}>
          <X className="" />
        </button>
        <h4 className="font-variant-numeric--primary sans font-bold leading-[36px] [margin-block-end:var(--gap)] text-[22px] text-grey-7">
          Cookie Settings
        </h4>
        {/* Cookie Settings Container */}
        <div className="flex flex-col gap-[var(--gap)]">
          {cookieSettings.map((cookieSetting, i) => {
            return (
              <React.Fragment key={cookieSetting.heading}>
                <CookieSetting
                  {...cookieSetting}
                  storedConsentTypes={props.storedConsentTypes}
                  addSelectedConsentTypes={consentTypes =>
                    setSelectedConsentTypes(prevSelectedConsentTypes => [
                      ...prevSelectedConsentTypes,
                      ...consentTypes,
                    ])
                  }
                  removeSelectedConsentTypes={consentTypes => {
                    setSelectedConsentTypes(prevSelectedConsentTypes => {
                      const newSelectedConstentTypes =
                        prevSelectedConsentTypes.filter(prevConsentType => {
                          if (consentTypes.includes(prevConsentType))
                            return false
                          return true
                        })
                      return newSelectedConstentTypes
                    })
                  }}
                />
                {i < cookieSettings.length - 1 && (
                  <hr className="border-b-grey-4" />
                )}
              </React.Fragment>
            )
          })}
        </div>
        <button
          className="button button--primary [margin:var(--gap)_auto_0]"
          onClick={() => {
            props.storeConsentTypes(selectedConsentTypes)
            props.closeModal()
          }}
        >
          Save Preferences
        </button>
      </div>
    </div>
  )
}
